// Re-skin shadcn de packages/hce/src/hce/offline/OfflineBanner.tsx — misma
// lógica (onCambioOutbox + navigator.onLine), solo cambia la UI (badge fijo
// en vez de Affix de Mantine).
import { CloudOff } from 'lucide-react';
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onCambioOutbox } from '../lib/audit/outbox';
import { Badge } from './ui/badge';

export function OfflineBanner(): JSX.Element | null {
  const { t } = useTranslation();
  const [pendientes, setPendientes] = useState(0);
  const [enLinea, setEnLinea] = useState(navigator.onLine);

  useEffect(() => onCambioOutbox(setPendientes), []);

  useEffect(() => {
    const marcarEnLinea = () => setEnLinea(true);
    const marcarSinLinea = () => setEnLinea(false);
    window.addEventListener('online', marcarEnLinea);
    window.addEventListener('offline', marcarSinLinea);
    return () => {
      window.removeEventListener('online', marcarEnLinea);
      window.removeEventListener('offline', marcarSinLinea);
    };
  }, []);

  if (enLinea && pendientes === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Badge variant={enLinea ? undefined : 'destructive'} className={enLinea ? 'bg-amber-500 text-white border-transparent' : undefined}>
        <CloudOff className="size-3.5" />
        {enLinea ? t('offline.pendientes', { count: pendientes }) : t('offline.sinConexion')}
      </Badge>
    </div>
  );
}
